"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var DataInterfaces_1 = require("../Types/DataInterfaces");
var table = {};
table[DataInterfaces_1.Portfolios.balanced] = 0.47;
table["RPBALANCED"] = 0.47;
table[DataInterfaces_1.Portfolios.moderate] = 0.49;
table["RPMODERATE"] = 0.49;
table[DataInterfaces_1.Portfolios.growth] = 0.44;
table["RPGROWTH"] = 0.44;
table[DataInterfaces_1.Portfolios.highgrowth] = 0.43;
table["RPHIGHGROWTH"] = 0.43;
exports.default = table;
//# sourceMappingURL=SSFeeTable.js.map